import { useEffect } from "react";
import useAbortLikeError from "./useAbortLikeError";

type Options = {
  enabled: boolean;
  onSettled: () => void;
  refetch: () => Promise<unknown>;
};

export default function useTriggeredRefetch({ enabled, onSettled, refetch }: Options) {
  const isAbortLikeError = useAbortLikeError();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    void refetch()
      .catch((error) => {
        if (!isAbortLikeError(error)) {
          throw error;
        }
      })
      .finally(onSettled);
  }, [enabled, isAbortLikeError, onSettled, refetch]);
}

